// Adapted from https://github.com/hungtcs/classed-elements/blob/master/packages/solidjs/lib/classed.tsx
// Specifically, the tailwind-merge support was added to make it easier to work with those classes.
/** @jsxImportSource solid-js */
import type { Component, ComponentProps, ValidComponent } from "solid-js";
import { Dynamic } from "solid-js/web";
import { twMerge } from "tailwind-merge";
import { domElements, type SupportedHTMLElements } from "./util";

export type ClassedElement<C extends ValidComponent> = (
  classes: TemplateStringsArray,
) => Component<ComponentProps<C>>;

function baseClassed<C extends ValidComponent>(
  component: C,
): ClassedElement<C> {
  return (classes: TemplateStringsArray) => {
    return (props) => (
      <Dynamic<C>
        component={component}
        {...props}
        class={twMerge(classes, props.class)}
      />
    );
  };
}

const classed = baseClassed as typeof baseClassed & {
  [E in SupportedHTMLElements]: ClassedElement<E>;
};

for (const element of domElements) {
  classed[element as SupportedHTMLElements] = classed(element);
}

export { classed, twMerge as classes };
